'use strict'

module.exports = {
  siteKey: '6LcOK9AUAAAAAMb6XPbdokZ7VPZhqA7MS2uIL926'
}



// WEBPACK FOOTER //
// ./src/plugins/vue-recaptcha-v3/config.js